import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation, faUserGraduate } from '@fortawesome/free-solid-svg-icons';
import { questionsRead } from '../components/Questions/useUnread';
import Conversation, { SafetyNote } from '../components/Questions/Conversation';

const API = process.env.REACT_APP_API_BASE_URL;
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('userData')}` } });

/* /student/questions: ask my teacher about classes and projects (parents + RoboMind can read it) */
const AskTeacher = () => {
  const [data, setData] = useState(null);
  const [error, setError] = useState('');

  const load = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/api/student/questions`, auth());
      setData(res.data);
      setError('');
      questionsRead(); // the menu badge updates
    } catch (err) {
      setError(err.response?.data?.error || 'We couldn’t load your messages.');
    }
  }, []);

  useEffect(() => {
    load();
    const id = setInterval(load, 60000); // new answers show up without reloading
    return () => clearInterval(id);
  }, [load]);

  const send = async (body, link) => {
    await axios.post(`${API}/api/student/questions`, { body, link }, auth());
    await load();
  };
  const report = async (m) => {
    const note = window.prompt('Why are you reporting this message? (optional)');
    if (note === null) return;
    await axios.post(`${API}/api/student/questions/report/${m.id}`, { note }, auth());
    await load();
  };

  return (
    <div className="rmq">
      <header className="rmq-head">
        <span className="rmq-eyebrow">Ask my teacher</span>
        <h1>Questions for my teacher</h1>
        <p>Stuck on a project or have a question about your class? Ask here. Your teacher usually answers within 24 hours.</p>
      </header>
      <SafetyNote me="student" />
      {error && !data ? (
        <p className="rmq-error">
          <FontAwesomeIcon icon={faTriangleExclamation} /> {error}
        </p>
      ) : !data ? (
        <div className="rmq-skel" aria-busy="true" />
      ) : !data.teacher ? (
        <div className="rmq-card rmq-pick">
          <p>
            <FontAwesomeIcon icon={faUserGraduate} /> You don’t have a teacher yet. When you do, you can ask your questions here.
          </p>
        </div>
      ) : (
        <section className="rmq-card">
          <div className="rmq-card-head">
            <img src={data.teacher.photo} alt="" onError={(e) => (e.currentTarget.style.visibility = 'hidden')} />
            <div>
              <b>{data.teacher.name}</b>
              <small>Your teacher</small>
            </div>
          </div>
          <Conversation
            me="student"
            names={{ teacher: data.teacher.name, student: 'You' }}
            messages={data.messages}
            onSend={send}
            onReport={report}
            left={data.left}
            limit={data.limit}
            placeholder={`Ask ${data.teacher.name} a question…`}
            emptyText={`No questions yet. Say hi to ${data.teacher.name} or ask about your project!`}
          />
        </section>
      )}
    </div>
  );
};

export default AskTeacher;
